import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ResendCooldownState {
    cooldownEnd: number | null; // timestamp in ms
}

const initialState: ResendCooldownState = {
    cooldownEnd: null,
};

const resendCooldownSlice = createSlice({
    name: "resendCooldown",
    initialState,
    reducers: {
        setCooldownEnd(state, action: PayloadAction<number>) {
            state.cooldownEnd = action.payload;
        },
        clearCooldown(state) {
            state.cooldownEnd = null;
        },
    },
});

// Selector for cooldown end
export const selectCooldownEnd = (state: { resendCooldown: ResendCooldownState }) => state.resendCooldown.cooldownEnd;

export const { setCooldownEnd, clearCooldown } = resendCooldownSlice.actions;
export default resendCooldownSlice.reducer;
